import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {SESSION_STORAGE, WebStorageService} from 'ngx-webstorage-service';
import {CookieService} from 'ngx-cookie-service';
import {OidcSecurityService} from "angular-auth-oidc-client";
import {catchError} from "rxjs/operators";
import {throwError} from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  developingMode = false;
  api = 'https://service.medis.studio';
  currentDirection = 'rtl';

  constructor(private http: HttpClient,
              @Inject(SESSION_STORAGE) private session: WebStorageService,
              private cookieService: CookieService,
              public oidcSecurityService: OidcSecurityService) {
    if (this.developingMode) {
      this.api = '';
    }
  }


  onSetLanguage(language, lan_id) {
    this.cookieService.set('dir', language);
    this.cookieService.set('lang', lan_id);
  }
  // apitest(){
  //   return this.http.get('https://getip.medis.land/');
  // }
  apiCall(method, route, body) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      lang: this.cookieService.get('lang'),
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
    if (method == 'post') {
      return this.http.post(this.api + route, body, {headers});
    } else if (method == 'get') {
      return this.http.get(this.api + route, {headers});
    } else if (method == 'delete') {
      return this.http.delete(this.api + route, {headers});
    } else if (method == 'put') {
      return this.http.put(this.api + route, body, {headers});
    }
  }

  handleError(error: any) {
    console.log('lalalalalalalala', error.status);
    if (error.status == 401) {
    }

    return throwError(error);
  }

  // apiCallKiosk(method, route, body) {
  
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     // Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   if (method == 'post') {
  //     return this.http.post(this.kioskApi + route, body, {headers});
  //   } else if (method == 'get') {
  //     return this.http.get(this.kioskApi + route, {headers});
  //   } else if (method == 'delete') {
  //     return this.http.delete(this.kioskApi + route, {headers});
  //   } else if (method == 'put') {
  //     return this.http.put(this.kioskApi + route, body, {headers});
  //   }
  // }

  // GetLanguages() {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/admin/GetLanguages', {headers});
  // }
  //
  // RegisterConfirm() {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get('https://service.medis.studio/api/Account/RegisterConfirm', {headers});
  // }

// -------------------------------------------------------------------training---------------------------------------------------------------------

  // GetSites() {
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //
  //   return this.http.get(this.api + '/api/admin/GetSites', {headers});
  // }
  //
  // AddSite(body) {
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.post(this.api + '/api/admin/AddSite', body, {headers});
  // }
  //
  // DeleteSite(id) {
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.delete(this.api + '/api/admin/DeleteSite/' + id, {headers});
  // }
  //
  // EditSite(id) {
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.get(this.api + '/api/admin/EditSite/' + id, {headers});
  // }
  //
  // UpdateSite(body) {
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.put(this.api + '/api/admin/UpdateSite/', body, {headers});
  // }
  //
  // GetSolutions(body) {
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.post(this.api + '/api/admin/GetSolutions/', body, {headers});
  // }
  //
  // EditSolution(id) {
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.get(this.api + '/api/admin/EditSolution/' + id, {headers});
  // }
  //
  // UpdateSolution(body) {
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.put(this.api + '/api/admin/UpdateSolution', body,{headers});
  // }
  //
  // AddSolution(body) {
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.post(this.api + '/api/admin/AddSolution', body, {headers});
  // }
  // DeleteSolution(id){
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.delete(this.api + '/api/admin/DeleteSolution/' + id, {headers});
  // }
  // GetServices(body) {
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.post(this.api + '/api/admin/GetServices/', body, {headers});
  // }
  // DeleteService(id){
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.delete(this.api + '/api/admin/DeleteService/' + id, {headers});
  // }
  // EditService(id){
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.get(this.api + '/api/admin/EditService/' + id, {headers});
  // }
  // AddService(body){
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.post(this.api + '/api/admin/AddService/',body, {headers});
  // }
  // UpdateService(body){
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.put(this.api + '/api/admin/UpdateService/',body, {headers});
  // }
  // GetSubServices(body){
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.post(this.api + '/api/admin/GetSubServices/', body, {headers});
  // }
  // AddSubService(body){
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.post(this.api + '/api/admin/AddSubService/',body, {headers});
  // }
  // EditSubService(id){
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.get(this.api + '/api/admin/EditSubService/' + id, {headers});
  // }
  // DeleteSubService(id){
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.delete(this.api + '/api/admin/DeleteSubService/' + id, {headers});
  // }
  // UpdateSubService(body){
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.put(this.api + '/api/admin/UpdateSubService/',body, {headers});
  // }
  // GetRequests(body){
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.post(this.api + '/api/admin/GetRequests/',body, {headers});
  // }
  // ChangeRequestStatus(body){
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.put(this.api + '/api/admin/ChangeRequestStatus/',body, {headers});
  // }
}
